import { useRef } from "react";
import { useTrack } from "@/hooks/useTrack/useTrack";
import { useBaseStore } from "@/store/store";
import { TimelineMode } from "../../components/TimelineModePicker/TimelineModePicker.decl";

export function useTimelineModePicker() {
  const { track } = useTrack();

  const mode = useBaseStore((store) => store.mode);
  const setMode = useBaseStore((store) => store.setMode);

  const previousMode = useRef<TimelineMode | null>(null);

  const handleOnClick = (givenMode: TimelineMode) => () => {
    if (givenMode === mode) {
      return;
    }

    previousMode.current = mode;
    setMode(givenMode);
    track("conversation_player_view_updated", {
      player_view: previousMode.current,
      new_player_view: givenMode,
    });
  };

  const handleOnClickSimple = handleOnClick("simple");
  const handleOnClickKaraoke = handleOnClick("karaoke");
  const handleOnClickSentiments = handleOnClick("sentiments");

  return {
    handleOnClickSimple,
    handleOnClickKaraoke,
    handleOnClickSentiments,
  };
}
